import {mapActions, mapGetters, mapMutations} from 'vuex'
import customAccesibilityTabs from '../config/before-mount/accesibility-tab-navigation'

export default {
  data() {
    return {
      customAccesibilityTabs
    }
  },

  computed: {
    ...mapGetters([
      'allComponentsMounted',
      'contraste',
      'getAccesibilityActive'
    ])
  },

  watch: {
    // allComponentsMounted(newVal) {
    //   console.log(`allComponentsMounted ${oldVal} to ${newVal}`)

    //   return newVal
    // },

    // contraste(newVal, oldVal) {
    //   console.log(`contrast has changed from ${oldVal} to ${newVal}`)
    //   this.applyContrasteCss()
    // }
  },

  created() {
    this.createdBehaviour()
  },

  mounted() {
    this.$nextTick(() => {
      this.mountedBehaviour()
    })
  },

  methods: {
    ...mapActions([
      'escucharAudio',
      'closeContraste',
      'componentMounted',
      'showAccessibilityModal',
      'closeAccessibilityModal',
      'checkAccessibilityTabs'
    ]),
    ...mapMutations(['registerComponent']),

    /**
     * Comprueba si el componente es válido para aplicar la lógica del mixin.
     * Evita errores en componentes internos de librerías (Element UI, etc.)
     */
    isValidComponent() {
      // 1. Si no hay store, no podemos hacer nada (evita el error 'commit of undefined')
      if (!this.$store) return false
      // 2. Opcional: Ignorar componentes que no tengan nombre
      if (!this.$options.name) return false

      // 3. Opcional: Ignorar componentes internos de Element UI
      // (sus nombres suelen empezar por El- o son cosas como DateTable)
      const ignoredComponents = ['DateTable', 'ElDatePicker', 'ElTimePicker', 'TimeSpinner']
      if (ignoredComponents.includes(this.$options.name)) return false

      return true
    },

    targetInput(event, selector = null, fromParent = false) {
      selector = selector === null ? 'input:first' : selector
      const $input = fromParent ?
        $(event.target).parent().find(selector) : $(event.target).find(selector)
      $input.focus()
    },

    handleKeystroke(event) {
      switch (event.code) {
        case 'Escape':
          this.$emit('close')
          break
        case 'Space':
        case 'Enter':
          event.preventDefault()
          $(event.target).click()
          break
        default:
      }
    },

    createdBehaviour() {
      // AÑADIR GUARDIA DE SEGURIDAD
      if (!this.isValidComponent()) return

      this.registerComponent(this.$options.name)
    },

    mountedBehaviour() {
      // AÑADIR GUARDIA DE SEGURIDAD
      if (!this.isValidComponent()) return

      this.componentMounted(this.$options.name)
      this.applyContrasteCss()
    },

    applyContrasteCss() {
      if (this.$options.name !== undefined && !this.$options.name.includes('ns-')) {
        // Lógica de contraste
      }
    }
  }
}
